import * as urls from "utils/contants/urls";
import * as Permissions from "utils/PerfilAcesso";

import { Icon } from 'react-icons-kit'; //https://react-icons-kit.vercel.app/iconset/md
import {barChart} from 'react-icons-kit/fa/barChart';
import {ic_question_answer_outline} from 'react-icons-kit/md/ic_question_answer_outline';
import {ic_source_outline} from 'react-icons-kit/md/ic_source_outline';
import {ic_library_books_outline} from 'react-icons-kit/md/ic_library_books_outline';

import { ItemMenu, LabelItem, MenuBody } from "./MenuStyle";
import React, { useState } from "react";
import {
  candidates,
  home,
  rails,
  steps,
  vaga,
  managers
} from "assets/icons/icons";

import { FormattedMessage } from "react-intl";
import { INITIAL_STATE as STAGE_INITIAL_STATE } from "store/ducks/stages";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Creators as railsAction } from "store/ducks/rails";
import { Creators as stageAction } from "store/ducks/stages";
import { Creators as vacancyAction } from "store/ducks/vacancy";
import { Creators as vacancyAssociationAction } from "store/ducks/vacancyAssociation";

const Menu = ({
  goTo,
  setIsAssociatingRequest,
  clearVacancyForm,
  resetSelectedStage,
  resetStageId,
  requestCleanRailsState,
  requestCleanStageState
}) => {
  const [selected, setSelected] = useState({
    dashboard: true,
    home: false,
    vacancy: true,
    steps: false,
    candidates: false,
    rails: false,
    managers: false,
    modules: false,
    contracts:false,
    

  });
  const updateRouter = newFocus => {
    setSelected({ ...newFocus });
    if(newFocus.dashboard)    goTo(urls.PLUG_AEC);
    if(newFocus.modules)      goTo(urls.APP);
    if (newFocus.documents)   goTo(urls.DOCUMENTS_CANDIDATES);
    if (newFocus.contracts)   goTo(urls.CONTRACTS_LIST);
    if (newFocus.doubts)      goTo(urls.DOUBTS_LIST);
  };

  return (
    <MenuBody>
      <ItemMenu
        selected={selected.dashboard}
        onClick={() =>
          updateRouter({
            dashboard: true,
            home: false,
            vacancy: false,
            steps: false,
            candidates: false,
            rails: false,
            managers: false,
            modules: false
          })
        }
      >
        <Icon style={{color:selected.dashboard ? '#005156' : ''}} size="1.5em" icon={barChart} />
        <LabelItem>
          <FormattedMessage id="menuPlugBar.dashboard" />
        </LabelItem>
      </ItemMenu>
   
      <ItemMenu
        selected={selected.doubts}
        onClick={() =>
          updateRouter({

            doubts: true
          })
        }
      >
        <Icon style={{color:selected.doubts ? '#005156' : ''}} size="1.5em" icon={ic_question_answer_outline} />
        <LabelItem>
          <FormattedMessage id="menuPlugBar.doubts" />
        </LabelItem>
      </ItemMenu>

      <ItemMenu
        selected={selected.documents}
        onClick={() =>
          updateRouter({

            documents: true
          })
        }
      >
        <Icon style={{color:selected.documents ? '#005156' : ''}} size="1.5em" icon={ic_source_outline} />
        <LabelItem>
          <FormattedMessage id="menuPlugBar.documents" />
        </LabelItem>
      </ItemMenu>  


      <ItemMenu
        selected={selected.contracts}
        onClick={() =>
          updateRouter({

            contracts: true
          })
        }
      >
       <Icon style={{color:selected.contracts ? '#005156' : ''}} size="1.5em" icon={ic_library_books_outline} />
        <LabelItem>
          <FormattedMessage id="menuPlugBar.contracts" />
        </LabelItem>
      </ItemMenu>



      <ItemMenu
        selected={selected.modules}
        onClick={() =>
          updateRouter({
            modules: true
          })
        }
      >
        {home()}
        <LabelItem>
          <FormattedMessage id="menuManagerBar.modules" />
        </LabelItem>
      </ItemMenu>
    </MenuBody>
  );
};

const MapStateToProps = state => ({});
const MapDispatchToProps = dispatch => ({
  goTo: route => dispatch(push(route)),
  setIsAssociatingRequest: value =>
    dispatch(vacancyAssociationAction.setIsAssociatingRequest(value)),
  clearVacancyForm: () => dispatch(vacancyAction.jobStartForm()),
  resetSelectedStage: () =>
    dispatch(stageAction.stageShowSuccess(STAGE_INITIAL_STATE.stage)),
  resetStageId: () => dispatch(stageAction.stageCreateSuccess(undefined)),
  requestCleanRailsState: () => dispatch(railsAction.requestCleanRailsState()),
  requestCleanStageState: () => dispatch(stageAction.requestCleanStageState())
});

export default connect(MapStateToProps, MapDispatchToProps)(Menu);
